/** Resets the live player to PLTV mode if next program does not support start over */
export const transitionProgram = (isNextProgramRestartable, isNextProgramNonRestartable, switchLive) => {
  isNextProgramNonRestartable.current = !isNextProgramRestartable;
  if (!isNextProgramRestartable) {
    switchLive();
  }
};
/** Changes the lookback stream on the same channel after current lookback stream ends */
export const changeLookbackStream = (
  lookbackProgramDetails,
  restartAssetId,
  useRoutePlaybackState,
  setHasChannelTuneInfo
) => {
  restartAssetId.current = lookbackProgramDetails?.metadata?.contentId;
  useRoutePlaybackState.current = false;
  setHasChannelTuneInfo(true);
};

/** Exits the lookback mode */
export const exitLookback = (exitLookbackMode) => {
  exitLookbackMode.current = true;
};
